export default __webpack_public_path__ + "static/media/markerPoint-floorPlan.5c900506.svg";